import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { trace } from '../../configuration/setup/trace';

export const rtkQueryLogger: Middleware = () => next => action => {
    if (isRejectedWithValue(action)) {
        const endpoint = action.meta?.arg?.endpointName;
        const status = action.payload?.status || action.error?.message;
        trace.error(`API request failed: ${endpoint}`, `Status: ${status}`);
    }

    return next(action);
};
